import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FaGraduationCap, FaHandsHelping, FaBookOpen } from 'react-icons/fa';

const FeaturesSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: FaGraduationCap,
      title: "features.education",
      description: "features.educationDesc"
    },
    {
      icon: FaHandsHelping,
      title: "features.support",
      description: "features.supportDesc"
    },
    {
      icon: FaBookOpen,
      title: "features.resources",
      description: "features.resourcesDesc"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">
          {t('home.featuresTitle')}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center p-6"
            >
              <div className="flex justify-center text-primary-500 mb-4">
                <feature.icon className="text-4xl" />
              </div>
              <h3 className="text-xl font-bold mb-2">
                {t(feature.title)}
              </h3>
              <p className="text-gray-600">
                {t(feature.description)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;